import DataTableTitle from "../../DataTableComponents/DataTableTitle";
import DeleteModal from "../../../Layout/Components/DeleteModal";
import CutiModal from "../components/CutiModal";

const RekapCutiColumns = (resetState) => [
  {
    name: <DataTableTitle text={"Nama Staf"} />,
    selector: (row) => row.nama,
    sortable: true,
  },
  {
    name: <DataTableTitle text={"Sakit"} />,
    selector: (row) => row.sakitCount,
    sortable: true,
    width: "10%",
  },
  {
    name: <DataTableTitle text={"Ijin"} />,
    selector: (row) => row.ijinCount,
    sortable: true,
    width: "10%",
  },
  {
    name: <DataTableTitle text={"Alpa"} />,
    selector: (row) => row.alpaCount,
    sortable: true,
    width: "10%",
  },
  {
    name: <DataTableTitle text={"Cuti"} />,
    selector: (row) => row.cutiCount,
    sortable: true,
    width: "10%",
  },
  {
    name: <DataTableTitle text={"Jatah Cuti"} />,
    selector: (row) => (
      <div className={row.hasGroup && `text-warning`}>{row.jatahCuti}</div>
    ),
    sortable: true,
    width: "15%",
  },
  // {
  //   name: <DataTableTitle text={"Operasi"} />,
  //   width: "15%",
  //   cell: (row) => (
  //     <div>
  //       <CutiModal create={false} data={row} resetState={resetState} />
  //       <DeleteModal
  //         name={"cuti"}
  //         // axiosDelete={daftarAkunAxiosDelete}
  //         pk={row.id_cuti}
  //         resetState={resetState}
  //       />
  //     </div>
  //   ),
  // },
];

export default RekapCutiColumns;
